import { Routes } from '@angular/router';

import { AuthService } from '../../auth/auth.service';
import { FormComponent } from '../form';

import { SearchComponent } from './search.component';

export const SearchRoutes: Routes = [
    {
        path: 'evaluation-search', // TODO revise naming
        canActivate: [AuthService],
        children: [
            {
                path: '',
                component: SearchComponent,
                children: [
                    {
                        path: 'drafts/:draftId',
                        component: FormComponent,
                    },
                    {
                        path: 'responses/:responseId',
                        component: FormComponent,
                    },
                ],
            },
        ],
    },
];
